<template>
  <div class="fillcontain" >
    <head-top></head-top>
    <div class="select_container">
      <el-select v-model="value" placeholder="图案分类" style="width: 200px" @change="change">
        <el-option
          v-for="item in options"
          :key="item.categoryId"
          :label="item.categoryName"
          :value="item.categoryId">
        </el-option>
      </el-select>
      <el-button type="primary" style="float: right;" @click="addFormVisible = true">新增图案</el-button>
    </div>
    <div class="table_container">
      <el-table
        :data="tableData"
        highlight-current-row
        style="width: 100%">
        <el-table-column
          type="index"
          label="序号"
          width="100">
        </el-table-column>
        <el-table-column
          property="imageName"
          label="图案名称">
        </el-table-column>
        <el-table-column
          property="categoryName"
          label="图案分类">
        </el-table-column>
        <el-table-column
          property="createTime"
          :formatter="formatDate"
          label="上传时间">
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="150">
          <template slot-scope="scope">
            <el-button @click="Viewmaterial(scope.$index, scope.row)" type="text" size="small">查看</el-button>
            <el-button @click="Editmaterial(scope.$index, scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="handleDelete(scope.$index, scope.row)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="Pagination">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="20"
          layout="total, prev, pager, next"
          :total="total">
        </el-pagination>
      </div>


      <!--新增图案-->
      <el-dialog title="新增图案" :visible.sync="addFormVisible" v-loading="loading">
        <el-form :model="addForm" label-width="80px" ref="addForm">
          <el-form-item label="图案名称" prop="name">
            <el-input v-model="addForm.name" auto-complete="off" maxlength="6" ></el-input>
          </el-form-item>
          <el-form-item label="图案分类" prop="classify">
            <el-select v-model="addForm.categoryId" placeholder="请选择">
              <el-option
                v-for="item in option"
                :key="item.categoryId"
                :label="item.categoryName"
                :value="item.categoryId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="图片附加" prop="img">
            <el-upload
              action="http://mapi.eduscb.com/smallpargramback/updaloFile/upload"
              :on-remove="handleRemove"
              :on-success='handlesuccess'
              :headers="myHeaders"
              :before-upload="beforeUploadimg"
              multiple
              :limit="1"
              :data = "{type:1}"
              :file-list="fileList"
              :on-exceed="handleExceed"
              v-model="addForm.imageUrls"
              list-type="picture">
              <div slot="tip" class="el-upload__tip">请上传213×149的jpg/png图片，且不超过500kb</div>
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="cancel">取消</el-button>
          <el-button type="primary" @click="addSubmit()" >提交</el-button>
        </div>
      </el-dialog>

      <!--编辑图案-->
      <el-dialog title="编辑图案" :visible.sync="addFormVisible2" v-loading="loading">
        <el-form :model="addForms" label-width="80px" ref="addForm">
          <el-form-item label="排版名称" prop="name">
            <el-input v-model="addForms.name" auto-complete="off" maxlength="6" ></el-input>
          </el-form-item>
          <el-form-item label="课程分类" prop="classify">
            <el-select v-model="addForms.classify" placeholder="请选择">
              <el-option
                v-for="item in option"
                :key="item.categoryId"
                :label="item.categoryName"
                :value="item.categoryId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="图片附加" prop="img">
            <el-upload
              action="http://mapi.eduscb.com/smallpargramback/updaloFile/upload"
              :on-remove="handleRemoves"
              :on-success='handlessuccess'
              :headers="myHeaders"
              :before-upload="beforeUploadimg"
              multiple
              :limit="1"
              :data = "{type:1}"
              :file-list="fileList"
              :on-exceed="handleExceed"
              list-type="picture">
              <div slot="tip" class="el-upload__tip">请上传213×149的jpg/png图片，且不超过500kb</div>
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="原图:" prop="name">
            <img v-bind:src="imageUrls" style="width: 80%">
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="cancel2">取消</el-button>
          <el-button type="primary" @click="addSubmits()" >提交</el-button>
        </div>
      </el-dialog>

      <!--查看排版-->
      <el-dialog title="查看图案" :visible.sync="addFormExpress" width="30%">
        <el-form :model="addForm" label-width="80px" ref="addForm">
          <el-form-item label="图案分类:" prop="categoryName">
            {{addForm.categoryName}}
          </el-form-item>
          <el-form-item label="图案名称:" prop="imageName">
            {{addForm.imageName}}
          </el-form-item>
          <el-form-item label="图片附件:" prop="img">
            <img v-bind:src="addForm.imageUrl" style="width: 80%">
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import headTop from '../components/headTop'
  import { getPatclassification,getPatternclass,getPatternAdd,getPatternDetail,getPatternMod,getPatternDel } from "../api/api"
  export default {
    inject: ['reload'],
    data(){
      return {
        options: [],
        option:[],
        value:'',
        tableData: [],
        limit: 20,
        total: 0,
        currentPage: 1,
        addFormVisible: false,//新增界面是否显示
        addFormVisible2:false,
        addFormExpress: false,
        //新增界面数据
        addForm: {
          name:'',
          categoryId:'',
          imageUrls:''
        },
        addForms: {
          name:'',
          classify:'',
          imageUrls:''
        },
        fileList:[],
        imageUrls:'',
        myHeaders: {token: sessionStorage.token},
        loading:false
      }
    },
    components: {
      headTop,
    },
    activated(){
      this.getPatclassification()
    },

    methods: {
      //时间戳转换
      formatDate:function (value){
        let dateee = new Date(value.updateTime).toJSON();
        return new Date(+new Date(dateee)+8*3600*1000).toISOString().replace(/T/g,' ').replace(/\.[\d]{3}Z/,'')
      },
      getPatclassification(){
        //  图案分类接口
        let params={
          pageNum:1,
          pageSize:this.limit,
        };
        getPatclassification(params).then(res=>{
          this.option = res.pageInfo
          this.options = res.pageInfo
          this.value = this.options[0].categoryId
          this.change()
        }).catch(error=>{
          console.log(error);
        })
      },
      change(){
        let params={
          pageNum:1,
          pageSize:this.limit,
          categoryId:this.value
        };
        //获取排版管理列表
        getPatternclass(params).then(res=>{
          this.total = res.total
          this.tableData = res.pageInfo
          this.currentPage = res.pageNum
        }).catch(error=>{
          console.log(error);
        })
      },
      changes(){
        let params={
          pageNum:this.currentPage,
          pageSize:this.limit,
          categoryId:this.value
        };
        //获取排版管理列表
        getPatternclass(params).then(res=>{
          this.total = res.total
          this.tableData = res.pageInfo
          this.currentPage = res.pageNum
        }).catch(error=>{
          console.log(error);
        })
      },
      addSubmit(){
        if (this.addForm.name == '' || this.addForm.imageUrls == '' ||this.addForm.categoryId == ''){
          this.$message({
            type: 'error',
            message: '请填写完整信息'
          });
        } else {
          this.loading = true
          let params={
            imageUrl:this.addForm.imageUrls,
            imageName:this.addForm.name.replace(/[^A-Za-z0-9\u4e00-\u9fa5]/g,''),
            categoryId:this.addForm.categoryId,
            operationId:JSON.parse(sessionStorage.getItem('user')).id,
          };
          getPatternAdd(params).then(res=>{
            if (res.state == true) {
              this.$message({
                type: 'success',
                message: res.msg
              });
              this.loading = false
              this.addForm = {}
              this.fileList = []
              this.addFormVisible = false
              this.getPatclassification()
            }else{
              this.$message({
                type: 'error',
                message: '请填写完整信息'
              });
              this.loading = false
            }
          }).catch(error=>{
            this.loading = false
            console.log(error)
          })
        }
      },
      cancel(){
        this.addForm = {}
        this.fileList = []
        this.addFormVisible = false
      },
      cancel2(){
        this.addForms = {}
        this.fileList = []
        this.addFormVisible2 = false
      },
      Viewmaterial(index,row){
        //  查看图案详情
        let params={
          imageId:row.imageId,
        };
        getPatternDetail(params).then(res=>{
          this.addFormExpress = true;
          this.addForm = res
        }).catch(error=>{
          console.log(error);
        })
      },
      Editmaterial(index,row){
        //  编辑排版
        this.addFormVisible2 = true;
        this.addForms.name = row.imageName
        this.imageUrls = row.imageUrl
        this.addForms.imageUrls = row.imageUrl
        this.addForms.operationId = JSON.parse(sessionStorage.getItem('user')).id
        this.addForms.classify = row.categoryId
        this.addForms.imageId = row.imageId
        console.log(this.addForms.imageUrls)
      },
      addSubmits(){
        if (this.addForms.name == '' || this.addForms.classify == ''){
          this.$message({
            type: 'error',
            message: '请填写完整信息'
          });
        } else {
          this.loading = true
          let params={
            imageUrl:this.addForms.imageUrls,
            imageName:this.addForms.name.replace(/[^A-Za-z0-9\u4e00-\u9fa5]/g,''),
            categoryId:this.addForms.classify,
            operationId:this.addForms.operationId,
            imageId:this.addForms.imageId
          };
          getPatternMod(params).then(res=>{
            if (res.state == true) {
              this.$message({
                type: 'success',
                message: res.msg
              });
              this.loading = false
              this.addForms = {}
              this.fileList = []
              this.addFormVisible2 = false
              this.getPatclassification()
            }else{
              this.$message({
                type: 'error',
                message: '请上传正确信息'
              });
              this.loading = false
            }
          }).catch(error=>{
            this.loading = false
            console.log(error)
          })
        }

      },
      handleDelete(index, row){
        //删除图案
        this.$confirm('确认删除该记录吗？', '提示', {
          // type: 'warning'
        }).then(() => {
          let params={
            imageId:row.imageId,
            operationId:JSON.parse(sessionStorage.getItem('user')).id,
          };
          getPatternDel(params).then(res=>{
            if (res.state == true) {
              this.$message({
                type: 'success',
                message: res.msg
              });
              this.tableData.splice(index, 1);
            }else{
              throw new Error(res.message)
            }
          }).catch(error=>{
            this.$message({
              type: 'error',
              message: res.msg
            });
          })
        })
      },
      handlesuccess(response, file, fileList){
        //response即为后台返回的全部内容
        if(file.response.state == true){
          this.addForm.imageUrls = file.response.url
        }else{
          console.log('解析失败')
        }
      },
      handlessuccess(response, file, fileList){
        //response即为后台返回的全部内容
        if(file.response.state == true){
          this.addForms.imageUrls = file.response.url
        }else{
          console.log('解析失败')
        }
      },
      beforeUploadimg(file) {
        if (['image/jpg', 'image/png', 'image/jpeg', 'image/gif'].indexOf(file.type) == -1) {
          this.$message.error('请上传正确的图片格式');
          return false
        }
      },
      handleRemove(file, fileList) {
        this.addForm.imageUrls = ''
      },
      handleRemoves(file, fileList) {
      },
      handleExceed(files, fileList) {
        this.$message.warning(`最多上传一张图片`);
      },

      handleCurrentChange(val) {
        this.currentPage = val;
        this.changes()
      },
    },
  }
</script>

<style lang="less">
  @import '../style/mixin';
  .table_container{
    padding: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/page/patMagent.vue